import Link from 'components/Link';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardLink: FunctionComponent<Props> = ({
    children,
    className = '',
    isDisabled = false,
    onClick,
    target,
    testId = TEST_ID,
    text = '',
    to = ''
}) => (
    <Link
        className={`${className} ${styles.cardLink}`}
        isDisabled={isDisabled}
        onClick={onClick}
        target={target}
        testId={testId}
        to={to}>
        {children || text}
    </Link>
);

export default CardLink;
